export enum DialogOptions {
    YesNoCancel = 0,
    OkCancel = 1
    }
